<template>
  <ul class="om-paginator__list flex wrap sb">
    <li v-if="page > 1" class="om-paginator__prev om-paginator__page" @click="changeAction(page - 1)"></li>
    <li v-if="pagesCount > 1" :class="[page === 1 ? 'active': '']" class="om-paginator__page" @click="changeAction(1)">{{ 1 }}</li>
    <li v-if="beforeDots" class="om-paginator__page om-paginator__dots">...</li>
    <!--<li v-for="n in pagesCount" class="om-paginator__page" :class="[page === n ? 'active': '']" @click="changeAction(n)">{{ n }}</li>-->
    <li v-for="n in (spread * 2 + 1)" class="om-paginator__page" v-if="n + page - (spread * 2) + 1 < pagesCount && n + page - (spread * 2) > 0" :class="[page === (n + page - (spread * 2) + 1) ? 'active': '']" @click="changeAction(n + page - (spread * 2) + 1)">{{ n + page - (spread * 2) + 1 }}</li>
    <li v-if="afterDots" class="om-paginator__page om-paginator__dots">...</li>
    <li v-if="pagesCount >= 2" :class="[page === pagesCount ? 'active': '']" class="om-paginator__page" @click="changeAction(pagesCount)">{{ pagesCount }}</li>
    <li v-if="page < pagesCount" @click="changeAction(page + 1)" class="om-paginator__next om-paginator__page"></li>
  </ul>
</template>
<script>
  /*
  * This component takes as properties items (of array), and itemsPerPage.
  * It returns chunk of array (page) as parameter of change event callback
  * */
  export default {
    name: 'paginator',
    data () {
      return {
        page: 1,
        requestPages: 1,
        pageItems: [],
        beforeDots: false,
        afterDots: false,
        head: 0,
        tail: 0
      }
    },
    props: {
      items: {
        'default': Array
      },
      itemsPerPage: Number,
      spread: {
        type: Number,
        'default': 2
      },
      passiveMode: {
        'default': false
      },
      request: {
        'default': null // it should be object {route: 'endpoint/uri', params: {'param1': 'value1'}}
      },
      updateForce: {
        'default': 1
      },
      active: {
        'default': true
      }
    },
    mounted () {
      this.changeAction(1)
    },
    methods: {
      changeAction (val) {
        if (!this.active) {
          this.$emit('change', [])
          return
        }
        if (!this.passiveMode) {
          this.page = val
          this.head = (this.page - 1) * this.thItemsPerPage
          this.tail = this.elementsCount - ((this.page) * this.thItemsPerPage)
          let end = this.head + this.thItemsPerPage
          if (end > this.elementsCount) {
            end = this.elementsCount
          }
          this.pageItems = this.items.slice(this.head, end)
          this.spreadConditioning()
          this.$emit('change', this.pageItems)
        } else {
          let params = typeof this.request.params === 'undefined' ? {} : this.request.params
          params['page'] = val
          params['items_per_page'] = this.itemsPerPage
          let path = this.$router.options.getApiRoute(this.request.route)
          this.$http.get(path, {params}).then((resp) => {
            if (resp.ok) {
              this.page = val
              this.pageItems = resp.body.items
              this.requestPages = resp.body.itemsCount
              this.spreadConditioning()
              this.$emit('change', this.pageItems)
              this.$emit('results-count', this.requestPages)
            }
          }, (resp) => {
            this.$helper.stdErrors(resp)
          })
        }
      },
      spreadConditioning () {
        this.beforeDots = (this.page - this.spread > this.spread)
        this.afterDots = ((Number(this.page) + Number(this.spread) + 1) < this.pagesCount)
      }
    },
    computed: {
      pagesCount () {
        return Math.ceil(this.elementsCount / this.thItemsPerPage)
      },
      elementsCount () {
        if (this.passiveMode) {
          return this.requestPages
        } else {
          return this.items.length
        }
      },
      thItemsPerPage () {
        return this.itemsPerPage
      }
    },
    watch: {
      itemsPerPage () {
        this.changeAction(1)
      },
      items () {
        this.changeAction(1)
      },
      updateForce () {
        if (this.passiveMode) {
          console.log('request params changed')
          this.changeAction(1)
        }
      }
    }
  }
</script>

<style lang="scss" src="../../../assets/scss/reusable/paginator.scss"></style>


// WEBPACK FOOTER //
// Paginator.vue?1a14a6fc